module.exports = __webpack_public_path__ + "img/neudorf-menu.65e9a628.jpg";